const body = document.body
const windowHeight = window.innerHeight
const button = document.querySelector('#js-hamburger')
const items = Array.from(document.querySelectorAll('.mobile-menu__item'))
const delay = 150
const step = 100
let locked = false

function menu() {
  const hasMenu = body.classList.contains('has-menu')

  if (!hasMenu && !locked) {
    locked = true
    body.classList.add('has-menu')
    body.style.height = windowHeight + 'px'
    button.classList.add('is-active')

    items.forEach((item, index) => {
      window.setTimeout(() => {
        item.classList.add('is-moving')
      }, (step * index) + (delay * 2))
    })

    window.setTimeout(() => {
      locked = false
    }, step * items.length)

  } else if (hasMenu && !locked) {

    const reversed = [...items].reverse()
    reversed.forEach((item, index) => {
      window.setTimeout(() => {
        item.classList.remove('is-moving')
      }, step * index)
    })
    window.setTimeout(() => {
      locked = false
      button.classList.remove('is-active')
      body.classList.remove('has-menu')
    }, (step * items.length) + delay)

  }
}

function init() {

  if (!button || !items.length) {
    return
  }

  button.addEventListener('click', () => {
    menu()
  })
}

export default init
